module.exports = __webpack_public_path__ + "media/images/landing_page/trees-7e917b4fb7b532e7e79ab774bb8fe0c5.jpg";